import React, { Component } from "react";
// import { Link } from 'react-router-dom'
// import { connect } from 'react-redux'
import "./styles.css";

class BttnYes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bttnClass: false,
      answer: ""
    };
    this.toggleBttnClass = this.toggleBttnClass.bind(this);
    // console.log(this.props);
  }
  toggleBttnClass() {
    this.setState({ bttnClass: !this.state.bttnClass });
    this.props.onClick && this.props.onClick(this.state.bttnClass);
  }

  render() {
    return (
      <div
        className={this.state.bttnClass ? "bttn-yes yes" : "bttn-yes"}
        onClick={this.toggleBttnClass}
      >
        <div className="circle">
          <span>{this.props.text}</span>
        </div>
        <div className="leafs">
          <div className="leaf" />
          <div className="leaf" />
          <div className="leaf" />
          <div className="leaf" />
          <div className="leaf" />
          <div className="leaf" />
          <div className="leaf" />
        </div>
      </div>
    );
  }
}

//export default connect()(BttnYes)

export { BttnYes };



// WEBPACK FOOTER //
// ./src/screens/Questionnaire/QuestionnaireYesNo/BttnYes.js